<template>
	<div @mouseover="clearAutoAdvance">
		<div class="container my-8">
			<div class="sizer flex justify-between items-center content-center">
				<button :disabled='currentItem === 0'
						class='mx-1 flex items-center rotate-180 justify-center p-0 text-center carousel-side-scroller-button'
						:class="[(start) ? 'btn-inactive':'btn-dark']"
						@click='navigatePrev'>
					<img :src="arrowIcon" alt="previous">
				</button>

				<span class="hidden sm:flex flex-row gap-2">
					<span v-for="(item, index) in items" 
						v-on:click="navigateExact(index)" 
						class="flex justify-center items-center w-10 h-10 text-lg rounded-full cursor-pointer" 
						:class="[(index === currentItem) ?  'bg-sky-200' : 'bg-sky-500']">{{ index + 1 }}</span>
				</span>

				<button :disabled='currentItem === (items.length - itemsFitWidth)'
						class='mx-1 btn-dark flex  items-center justify-center p-0 carousel-side-scroller-button'
						:class="[(end) ? 'btn-inactive':'btn-dark']"
						@click='navigateNext'>
					<img :src="arrowIcon" alt="next" class="">
				</button>
			</div>
		</div>

		<div class="w-full overflow-x-hidden">
			<div class="container w-full">
				<div ref="holder" class="flex flex-nowrap items-stretch inner align-stretch gap-1"
					:style="carouselSideScrollerStyles">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {onMounted} from "vue";

export default {
    name: "DayCarousel",
    props: {
        cardWidth: {
            type: Number,
            default: 400
        },
        numberOfItems: {
            type: Number,
            default: 0
        },
        arrowIcon: {
            type: String,
            default: ''
        },
        gap: {
            type: Number,
            default: 32
        }
    },
	data() {
        return {
			items: [],
			widths: [],
			trueCardWidth: 0,
			pageWidth: 0,
			carouselWidth: 0,
			currentItem: 0,
			cardGap: 32,
			reportedCardWidth: 0,
			scrollOffset: 0,
			scrollAreaWidth: 0,
			changing: false,
			activeDiff: 0,
			autoAdvanceInterval: null,
            autoAdvancePaused: false,
		}
    },
    computed: {
        sumWidths: function () {
            let widths = 0;
			for (let i = 0; i < this.items.length; i++) {
                widths += this.items[i].clientWidth + this.cardGap;
            }
			return widths;
        },
        scrollAllowedMax: function () {
            return this.sumWidths - this.carouselWidth + this.activeDiff;
        },
        offset: function () {
            if (this.scrollOffset > this.scrollAllowedMax) {
				return this.scrollAllowedMax;
            }
            if (this.scrollOffset < 0) {
                return 0;
            }
			let activeSlideOffset = (this.changing === 'right') ? this.activeDiff : 0;
            return this.scrollOffset - activeSlideOffset;
        },
        carouselSideScrollerStyles: function () {
            return 'margin-left: -' + this.offset + 'px; gap: ' + this.cardGap + 'px;';
        },
        itemsFitWidth: function () {
            return Math.floor(this.carouselWidth / this.scrollBlockWidth);
        },
        start: function () {
            return (this.offset === 0);
        },
        end: function () {
            return (this.offset === this.scrollAllowedMax);
        },
        middle: function () {
            return (!this.start && !this.end);
        }
    },
    watch: {
		currentItem: function () {
			// this.setActiveSlide();
			this.setClientWidths();
		}
    },
    components: {},
    created: function () {
        // this.items = this.$slots.default();

    },
    beforeDestroy: function () {
        window.removeEventListener("resize", this.setWidths);
        this.clearAutoAdvance();
    },
    destroyed: function () {
        window.removeEventListener("resize", this.setWidths);
        this.clearAutoAdvance();
    },
    mounted: function () {
        this.items = this.$refs.holder.children;
        this.setWidths();
        this.reportedCardWidth = parseInt(this.cardWidth);
        window.addEventListener("resize", this.setWidths);
        this.cardGap = parseInt(this.gap);

        this.startAutoAdvance();
        this.$refs.holder.addEventListener('mouseover', this.clearAutoAdvance);
        this.$refs.holder.addEventListener('mouseout', this.startAutoAdvance);
    },
    methods: {
        setWidths: function () {
            this.scrollOffset = 0;
			this.carouselWidth = this.$refs.holder.clientWidth;
			this.setClientWidths();
			this.activeDiff = (this.carouselWidth < 600) ? 0 : 200;
        },
		setClientWidths: function () {
			let item = this.$refs.holder.children[this.currentItem];
			let children = this.$refs.holder.children;
			if (document.querySelector('.day-carousel-item.active')) {
				document.querySelector('.day-carousel-item.active').classList.remove('active');
			}
			item.classList.add('active');
			let tempScroll = 0;
			let borderOffset = 4;
			for (let i = 0; i < this.currentItem; i++) {
				tempScroll += children[i].clientWidth + this.cardGap + borderOffset;
            }
			this.scrollOffset = tempScroll;
		},
		navigateToItem: function (index) {
			this.clearAutoAdvance();
			if (index < 0) {
				index = 0;
			}
			if (index >= this.items.length) {
				index = this.items.length - 1;
			}
			if (index > this.currentItem) {
				this.changing = 'right';
			} 
			if (index < this.currentItem) {
				this.changing = 'left';
			}
			this.currentItem = index;
			// this.setActiveSlide();
			// this.startAutoAdvance();
		},
        navigateExact: function (index) {
            let scrollWidth = 0;
            this.navigateToItem(index);
        },
        navigateNext: function () {
            this.changing = 'right';
			this.navigateToItem(this.currentItem+1);
        },
        navigatePrev: function () {
            this.changing = 'left';
			this.navigateToItem(this.currentItem-1);
        },
        setActiveSlide: function () {

        },
        startAutoAdvance: function () {
            this.autoAdvanceInterval = setTimeout(() => {
                this.navigateNext();
				this.startAutoAdvance();
            }, 6000);
        },
        clearAutoAdvance: function () {
            if (this.autoAdvanceInterval) {
                clearTimeout(this.autoAdvanceInterval);
                this.autoAdvanceInterval = null;
            }
        }
    },
    render: h => h(vueApp),
}
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0;
    background: transparent; /* make scrollbar transparent */
}

.inner {
    transition: margin-left 0.5s ease-in-out;
}

:slotted(.hide-inactive),
:slotted(.hide-inactive p) { 
	height: 0;
	opacity: 0;
	overflow: hidden;
	transition: all 0.5s 0.5s ease-in-out;
}


:slotted(.active .hide-inactive),
:slotted(.active .hide-inactive p) {
	height: auto;
	opacity: 1;
	overflow: visible;
	transition: all 0.5s 0.5s ease-in-out;
}

:slotted(h3) {
	text-align: center;
	transform: scale(0.7);
	transition: all 0.5s ease-in-out;
	max-width: 300px;
}

:slotted(.active h3) {
	transform: scale(1);
	text-align: center;
	transition: all 0.5s ease-in-out;
	max-width: 320px;
}

</style>
<style>
	.day-carousel-item {
		width: 310px;
		transition: width 0.5s ease-in-out;
	}
	.day-carousel-item p {
		font-size: 16px;
  		line-height: 1.4;
	}
	@media (min-width: 400px) {
		.day-carousel-item {
			width: 310px;
			transition: width 0.5s ease-in-out;
		}
		.day-carousel-item p {
			font-size: 20px;
		}
	}

	.active {
        width: 310px;
        transition: width 0.5s ease-in-out;
    }
	
	@media (min-width: 400px) {
		.active {
			width: 300px;
			transition: width 0.5s ease-in-out;
		}
	}

    @media (min-width: 600px) {
		.day-carousel-item {
			width: 400px;
			transition: width 0.5s ease-in-out;
		}

        .active {
            width: 600px;
            transition: width 0.5s ease-in-out;
        }
    }

</style>